import React from "react";
import DocumentAchatEntity from "./DocumentAchatEntity";

const DemandeAchat = () => {
    return <DocumentAchatEntity type="Demande achat" title="Demandes Achat" endpoint="DemandeAchat" />;
};

export default DemandeAchat;
